import filterStore from '../store/modules/filters';
import paginationStore from '../store/modules/pagination';

export default {
  filter: filterStore,
  pagination: paginationStore,
};
